/* ============================================================
   ECADRA — Product page JS (المرحلة 2)
   gallery · variant pills · quantity · AJAX add-to-cart (بيفتح الـ drawer) · sticky bar
   ============================================================ */
(function () {
  'use strict';
  var root = document.querySelector('[data-product-root]');
  if (!root) return;
  var E = window.ECADRA || {};

  var jsonEl = document.querySelector('[data-product-json]');
  var product = jsonEl ? JSON.parse(jsonEl.textContent) : null;

  function qs(s, c) { return (c || document).querySelector(s); }
  function qsa(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }

  /* ---------- 1) المعرض ---------- */
  function showMedia(mediaId) {
    qsa('.e-product__media', root).forEach(function (m) {
      m.classList.toggle('is-active', m.dataset.mediaId === String(mediaId));
    });
    qsa('[data-thumb]', root).forEach(function (t) {
      t.classList.toggle('is-active', t.dataset.mediaId === String(mediaId));
    });
  }
  qsa('[data-thumb]', root).forEach(function (t) {
    t.addEventListener('click', function () { showMedia(t.dataset.mediaId); });
  });

  /* swipe بالصباع على الصورة الكبيرة (موبايل) — صورة بعد صورة (إسلام 12/10) */
  (function () {
    var stage = qs('.e-product__main-media', root);
    if (!stage) return;
    var x0 = null, y0 = null;
    stage.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) { x0 = null; return; }
      x0 = e.touches[0].clientX; y0 = e.touches[0].clientY;
    }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var t = e.changedTouches[0], dx = t.clientX - x0, dy = t.clientY - y0;
      x0 = null;
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.2) return;
      var items = qsa('.e-product__media', root);
      if (items.length < 2) return;
      var i = items.findIndex(function (m) { return m.classList.contains('is-active'); });
      var rtl = (document.documentElement.getAttribute('dir') || '').toLowerCase() === 'rtl';
      var step = (dx < 0) !== rtl ? 1 : -1;
      var next = items[(Math.max(i, 0) + step + items.length) % items.length];
      showMedia(next.dataset.mediaId);
      var th = qs('[data-thumb][data-media-id="' + next.dataset.mediaId + '"]', root);
      if (th && th.scrollIntoView) th.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
    }, { passive: true });
  })();

  /* ---------- 2) الكمية ---------- */
  var qtyInput = qs('[data-qty-input]', root);
  var minus = qs('[data-qty-minus]', root);
  var plus = qs('[data-qty-plus]', root);
  function setQty(n) { if (qtyInput) qtyInput.value = Math.max(1, n); }
  if (minus) minus.addEventListener('click', function () { setQty(parseInt(qtyInput.value || '1', 10) - 1); });
  if (plus) plus.addEventListener('click', function () { setQty(parseInt(qtyInput.value || '1', 10) + 1); });

  /* ---------- 3) الـ variants ---------- */
  var variantIdInput = qs('[data-variant-id]', root);
  var atcBtn = qs('[data-atc]', root);
  var atcText = qs('[data-atc-text]', root);
  var stickyAdd = qs('[data-sticky-add]');
  var stickyPrice = qs('[data-sticky-price]');
  var stickyCompare = qs('[data-sticky-compare]');

  function money(cents) {
    var fmt = (E.moneyFormat || '{{amount}}');
    return fmt.replace(/\{\{\s*amount[^}]*\}\}/, (cents / 100).toFixed(2));
  }

  function selectedOptions() {
    return qsa('.e-variant', root).map(function (fs) {
      var checked = qs('input:checked', fs);
      return checked ? checked.value : null;
    });
  }

  function findVariant(opts) {
    if (!product) return null;
    return product.variants.find(function (v) {
      return v.options.every(function (o, i) { return o === opts[i]; });
    });
  }

  function updateVariantUI(variant) {
    if (!variant) {
      if (atcBtn) { atcBtn.disabled = true; }
      if (atcText) atcText.textContent = (window.ECADRA_T && ECADRA_T.unavailable) || 'Unavailable';
      return;
    }
    if (variantIdInput) variantIdInput.value = variant.id;

    /* السعر */
    var priceEl = qs('[data-price]', root);
    var compareEl = qs('[data-compare-price]', root);
    var badgeEl = qs('[data-off-badge]', root);
    if (priceEl) priceEl.innerHTML = money(variant.price);
    var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
    if (compareEl) {
      compareEl.hidden = !onSale;
      if (onSale) compareEl.innerHTML = money(variant.compare_at_price);
    }
    if (badgeEl) {
      badgeEl.hidden = !onSale;
      if (onSale) {
        if (badgeEl.dataset.badgeType === 'percent') {
          badgeEl.textContent = Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price) + '% OFF';
        } else {
          badgeEl.textContent = ((variant.compare_at_price - variant.price) / 100).toFixed(2) + ' OFF';
        }
      }
    }
    if (stickyPrice) stickyPrice.innerHTML = money(variant.price);
    if (stickyCompare) {
      stickyCompare.hidden = !onSale;
      if (onSale) stickyCompare.innerHTML = money(variant.compare_at_price);
    }

    /* SKU */
    var skuEl = qs('[data-sku]', root);
    if (skuEl) {
      skuEl.textContent = variant.sku || '';
      skuEl.classList.toggle('hidden', !variant.sku);
    }

    /* التوفر */
    var available = variant.available;
    if (atcBtn) atcBtn.disabled = !available;
    if (stickyAdd) stickyAdd.disabled = !available;
    if (atcText) atcText.textContent = available
      ? ((window.ECADRA_T && ECADRA_T.addToCart) || 'ADD TO CART')
      : ((window.ECADRA_T && ECADRA_T.soldOut) || 'SOLD OUT');

    /* صورة الـ variant */
    if (variant.featured_media) showMedia(variant.featured_media.id);

    /* تحديث الـ URL */
    if (history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState({}, '', url.toString());
    }
  }

  qsa('[data-option-input]', root).forEach(function (input) {
    input.addEventListener('change', function () {
      var fs = input.closest('.e-variant');
      var valueLabel = qs('[data-option-value]', fs);
      if (valueLabel) valueLabel.textContent = input.value;
      updateVariantUI(findVariant(selectedOptions()));
    });
  });

  /* ---------- 4) الإضافة للكارت (AJAX → drawer) ---------- */
  var form = document.getElementById('EcadraProductForm');
  function addToCart() {
    if (!form || (atcBtn && atcBtn.disabled)) return;
    if (atcBtn) atcBtn.classList.add('is-loading');
    var data = new FormData(form);
    fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: data })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent('ecadra:cart:added', { detail: { item_count: cart.item_count } }));
      })
      .catch(function (err) {
        /* مفيش إعادة إرسال للفورم — عشان ميحصلش إضافة مرتين */
        console.warn('ECADRA add-to-cart failed', err);
      })
      .finally(function () { if (atcBtn) atcBtn.classList.remove('is-loading'); });
  }
  if (form) form.addEventListener('submit', function (e) {
    /* لو الكارت drawer مقفول من الإعدادات سيب الفورم يتبعت عادي */
    if (!document.getElementById('CartDrawer')) return;
    e.preventDefault();
    addToCart();
  });
  if (stickyAdd) stickyAdd.addEventListener('click', addToCart);

  /* ---------- 5) الـ Sticky bar ---------- */
  var sticky = document.querySelector('[data-sticky-atc]');
  var buyBox = qs('.e-product__buy', root);
  if (sticky && buyBox && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      var entry = entries[0];
      /* أظهر الشريط فقط لما صندوق الشراء يعدّي فوق الشاشة (يعني نزلت تحته)،
         مش وهو لسه تحت الشاشة وقت فتح الصفحة — ده اللي كان بيعمل الومضة */
      var passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      sticky.classList.toggle('is-visible', passed);
      sticky.setAttribute('aria-hidden', passed ? 'false' : 'true');
    }, { rootMargin: '-80px 0px 0px 0px' });
    io.observe(buyBox);
  }

  /* ---------- 6) الوصف: preview + View more ---------- */
  var descEl = qs('.e-product__desc', root);
  if (descEl) {
    var descBody = descEl.querySelector('[data-desc-body]');
    var descBtn = descEl.querySelector('[data-desc-more]');
    if (descBody && descBtn) {
      var syncDesc = function () {
        if (descEl.classList.contains('is-open')) return;
        if (window.innerWidth >= 990) {
          /* ديسكتوب: حدّ الوصف لغاية نهاية معرض الصور (آخر صورة مصغّرة) */
          var gallery = qs('.e-product__gallery', root);
          if (gallery) {
            var h = Math.round(gallery.getBoundingClientRect().bottom - descBody.getBoundingClientRect().top);
            if (h > 120) descBody.style.maxHeight = h + 'px';
          }
        } else {
          descBody.style.maxHeight = ''; /* موبايل: سطرين من الـ CSS */
        }
        descBtn.hidden = descBody.scrollHeight <= descBody.clientHeight + 4;
      };
      descBtn.addEventListener('click', function () {
        var open = descEl.classList.toggle('is-open');
        if (open) {
          descBody.style.maxHeight = descBody.scrollHeight + 'px';
          descBtn.textContent = descBtn.dataset.less || 'View less';
        } else {
          descBtn.textContent = descBtn.dataset.more || 'View more';
          descBody.style.maxHeight = '';
          syncDesc();
          descEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      });
      if (document.readyState === 'complete') syncDesc();
      else window.addEventListener('load', syncDesc);
      var descRT;
      window.addEventListener('resize', function () { clearTimeout(descRT); descRT = setTimeout(syncDesc, 150); });
    }
  }
})();